module.exports = __webpack_public_path__ + "img/loyalty-program-article-icon.fea13b29.svg";